import { useContext } from 'react';
import { NotificationsContext } from '../store/notifications.context';
export function useNotifications() {
    return useContext(NotificationsContext);
}
//# sourceMappingURL=useNotifications.js.map